import React from 'react'
import ImgSlider from './Carousel'
import Cards from './cards'
const Home = () => {
  return (
    <>
    <ImgSlider/>
    <Cards/>
    </>
  )
}

export default Home